import { createActionType } from "../../utils/redux"

const namespace = 'orders_';

export const FETCHING_ORDER_SUCCESS = createActionType(namespace,'FETCHING_ORDER_SUCCESS');
export const FETCHING_ORDER_REQUEST = createActionType(namespace,'FETCHING_ORDER_REQUEST');
export const FETCHING_ORDER_FAILURE = createActionType(namespace,'FETCHING_ORDER_FAILURE');